import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // expertRegistration: {},
        // announcementContent: {},
        // userInfo: {},
        // search: '',
        navPath: {
            path: '',
            name: ''
        },
        token: null,
        user: null,
        searchValue: '',
    },
    getters: {
        getUser(state) {
            return state.user;
        },
    },

    mutations: {

        setUser(state, user) {
            console.log('setUser')
            state.user = user;
            state.token = user.jwtTokenName;

            localStorage.setItem('user', JSON.stringify(user));
        },
        clearUser(state) {
            console.log('setUser')
            state.user = null;
            state.token = null;
            state.navPath = {
                path: '',
                name: ''
            };
            localStorage.removeItem('user');
        },
        initializeStore(state) {
            // 检查LocalStorage中是否有已保存的用户信息，并将其恢复到store中
            if (localStorage.getItem('user')) {
                state.user = JSON.parse(localStorage.getItem('user'));
                state.token = state.user.jwtTokenName;
            }
        },

        SET_SEARCH(state, data) {
            state.search = data
        },
        SET_NAVPATH(state, data) {
            state.navPath = data
        },
        SET_SEARCHVALUE(state, data) {
            state.searchValue = data
        },

    },
    actions: {
        setUser({commit}, user) {
            commit('setUser', user);
        },
        clearUser({commit}) {
            commit('clearUser');
        },
        setNavPath({commit}, data) {
            commit('SET_NAVPATH', data)
        },
        setSearchValue({commit}, data) {
            console.log(data)
            commit('SET_SEARCHVALUE', data)
        },


    },

    modules: {},
    plugins: [createPersistedState()]
})
